function index() {
  return (
    <div>404</div>
  )
}

export default index
